<sh-card>
  <app-spare-parts-tabs
    [countDisplay]="ticketCountDisplay$ | async"
    (tabChange)="selectedTab.set($event)"
  ></app-spare-parts-tabs>

  <api-call-gate
    [apiCall]="sparePartsOverviewService.getSparePartsOverview"
    loadingLabel="{{ 'spareParts.loadingTickets' | translate }}"
  >
    <ng-template #lastSuccessfulData>
      @switch (selectedTab()) {
        @case (TAB_SERVICE_TICKETS) {
          @let topTicketsData = topTickets$ | async;
          @if (topTicketsData?.length > 0) {
            <app-service-tickets
              [tickets]="topTicketsData"
              (sortChange)="onTicketsSortChange($event)"
            ></app-service-tickets>
          } @else {
            <sh-empty-state
              icon="list-viewmode"
              icon-color="secondary"
              header="{{ 'spareParts.emptyState.noDataPastYear' | translate }}"
              label="{{ 'spareParts.emptyState.serviceTicket' | translate }}"
            >
            </sh-empty-state>
          }
        }
        @case (TAB_SERVICE_PARTS) {
          @let partsData = topServiceParts$ | async;
          @if (partsData?.length > 0) {
            <app-most-consumed-widget
              [mostConsumedDescription]="
                (mostConsumedPartData$ | async)?.description
              "
              [units]="(mostConsumedPartData$ | async)?.totalConsumptionCount"
            ></app-most-consumed-widget>
            <app-service-parts
              [parts]="partsData"
              (sortChange)="onPartsSortChange($event)"
            ></app-service-parts>
          } @else {
            <sh-empty-state
              icon="list-viewmode"
              icon-color="secondary"
              header="{{ 'spareParts.emptyState.noDataPastYear' | translate }}"
              label="{{ 'spareParts.emptyState.servicePart' | translate }}"
            >
            </sh-empty-state>
          }
        }
      }
    </ng-template>
    @let error = sparePartsOverviewService.getSparePartsOverview.error$ | async;
    @if (error?.status === 404) {
      <ng-template #error>
        @switch (selectedTab()) {
          @case (TAB_SERVICE_TICKETS) {
            <sh-empty-state
              icon="list-viewmode"
              icon-color="secondary"
              header="{{ 'spareParts.emptyState.noDataPastYear' | translate }}"
              label="{{ 'spareParts.emptyState.serviceTicket' | translate }}"
            >
            </sh-empty-state>
          }
          @case (TAB_SERVICE_PARTS) {
            <sh-empty-state
              icon="list-viewmode"
              icon-color="secondary"
              header="{{ 'spareParts.emptyState.noDataPastYear' | translate }}"
              label="{{ 'spareParts.emptyState.servicePart' | translate }}"
            >
            </sh-empty-state>
          }
        }
      </ng-template>
    }
  </api-call-gate>
  <sh-button
    size="auto"
    slot="footer"
    color="secondary"
    (click)="openDetailedView()"
    (keydown.enter)="openDetailedView()"
    label="{{ redirectButtonLabel() | translate }}"
  ></sh-button>
</sh-card>
